<template>
    <div class="cinema_location_wrap">
        <div
            id="map_container"
            style="width: 100%; height: 100vh; position: relative"
        ></div>
    </div>
</template>

<script>
import AMap from "AMap";
export default {
    data() {
        return {};
    },
    components: {},
    mounted() {
        this.init();
    },
    created() {},
    methods: {
        init: function () {
            var map = new AMap.Map("map_container", {
                resizeEnable: true,
                zoom: 11,
                center: [116.397428, 39.90923],
            });
            // 构造点标记
            var marker = new AMap.Marker({
                icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [121.527246, 31.226786],
            });
            // 构造矢量圆形
            var circle = new AMap.Circle({
                center: new AMap.LngLat("121.527246", "31.226786"), // 圆心位置
                radius: 30, //半径
                strokeColor: "#b1d0f2", //线颜色
                strokeOpacity: 1, //线透明度
                strokeWeight: 1, //线粗细度
                fillColor: "#d7e4f0", //填充颜色
                fillOpacity: 0.8, //填充透明度
            });

            // 将以上覆盖物添加到地图上
            // 单独将点标记添加到地图上
            // map.add(marker);
            // add方法可以传入一个覆盖物数组，将点标记和矢量圆同时添加到地图上
            map.add([marker, circle]);
            map.setFitView();
        },
    },
};
</script>
<style scoped lang="scss">
.cinema_location_wrap {
}
</style>


// WEBPACK FOOTER //
// src/pages/movie/cinemaLocation.vue